import Button from 'components/Button'

import Google from 'assets/icons/google.svg'
import Github from 'assets/icons/github.svg'
import clsx from 'clsx'

const ThirdPartyButton = ({
  title,
  className,
  href,
  icon,
}: ThirdPartyButtonProps) => {
  return (
    <Button
      component='a'
      variant='custom'
      className={clsx(
        `flex justify-center whitespace-nowrap space-x-2.5 items-center w-full border px-8 py-4 text-xs`,
        className
      )}
      href={href}>
      <img className='inline-block w-5' src={icon} alt='' />
      <span>Continue with {title}</span>
    </Button>
  )
}

type ThirdPartyButtonProps = {
  title: string
  className?: string
  href: string
  icon: string
}

const ThirdParty = () => {
  return (
    <>
      {/*
        note that this component will be affected by the
        spacing of its parent for example if use space-y-*
      */}
      <div className='flex flex-col space-y-4 lg:flex-row lg:space-x-2.5 lg:space-y-0'>
        <ThirdPartyButton
          title='Google'
          icon={Google}
          className='text-white bg-google border-google ring-blue-300'
          href={`https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/userinfo.email%20https://www.googleapis.com/auth/userinfo.profile&client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${window.location.origin}${process.env.REACT_APP_GOOGLE_REDIRECT_URI}&response_type=code`}
        />
        <ThirdPartyButton
          title='GitHub'
          icon={Github}
          className='border-gray-400 ring-gray-300'
          href={`https://github.com/login/oauth/authorize?scope=user&client_id=${process.env.REACT_APP_GITHUB_CLIENT_ID}&redirect_uri=${window.location.origin}${process.env.REACT_APP_GITHUB_REDIRECT_URI}`}
        />
      </div>
      <div className='flex items-center justify-center'>
        <hr className='w-full' />
        <span className='text-sm text-gray-300 px-14 font-roboto'>Or</span>
        <hr className='w-full' />
      </div>
    </>
  )
}

export default ThirdParty
